// extracted by mini-css-extract-plugin
export default {"container":"auction-print_container__Axfyu","tbd":"auction-print_tbd__1PHu2"};